import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EmbeddedViewRef,
    OnDestroy,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';

import { Subject } from 'rxjs';

@Component({
    selector: 'ridango-modal-wrapper',
    templateUrl: './modal-wrapper.component.html',
})
export class ModalWrapperComponent implements AfterViewInit, OnDestroy {
    private readonly _onClose = new Subject<boolean>();

    public componentRef: EmbeddedViewRef<any>;
    public childComponent: TemplateRef<any>;
    public onClose$ = this._onClose.asObservable();

    @ViewChild('modalContent', { read: ViewContainerRef, static: true }) modalContent: ViewContainerRef;

    constructor(private changeDetector: ChangeDetectorRef, public eRef: ElementRef) {}

    ngAfterViewInit() {
        // after wrapper view is loaded, add child component and run change detection
        this.loadModalContent(this.childComponent);
        this.changeDetector.detectChanges();
    }

    ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
        }
    }

    loadModalContent(content: TemplateRef<any>) {
        // place modal content inside the modal content placeholder
        this.modalContent.clear();
        this.componentRef = this.modalContent.createEmbeddedView(content);
    }

    close() {
        this._onClose.next();
    }
}
